import React from 'react';
import { Grid, Paper, Typography, Skeleton } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

import { useIntl } from 'react-intl';
import { useMessages } from 'modules/intl';
import { AutoAcceptComponent } from './AutoAcceptComponent';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(0, 2),
    marginRight: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    minWidth: '47%',
    justifyContent: 'center'
  },
  acceptContainer: {
    display: 'flex',
    flexDirection: 'column',
    margin: theme.spacing(1)
  },
  grid: {
    display: 'flex',
    flexDirection: 'row'
  },
  span: {
    alignSelf: 'center',
    margin: theme.spacing(0, 2),
    color: theme.palette.text.secondary,
    fontSize: theme.spacing(1.8)
  },
  skeleton: {
    backgroundColor: theme.skelton.color,
    width: '100%',
    height: theme.spacing(4.5)
  }
}));

const labels = ['insights.autoAccept.SYSTEM', 'insights.autoAccept.USER'];
export const AutoAcceptSkeleton: React.FC = () => {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const messages = useMessages(labels);

  return (
    <Paper
      className={classes.container}
      elevation={3}
      data-testid={'auto-accept-skeleton-container'}
    >
      <Grid flexWrap={'wrap'} className={classes.grid}>
        <AutoAcceptComponent
          label={messages['insights.autoAccept.SYSTEM']}
          element={
            <Skeleton
              className={classes.skeleton}
              data-testid="auto-accept-percentage-skeleton"
            />
          }
        />
        <Typography
          variant="caption"
          whiteSpace="nowrap"
          className={classes.span}
          data-testid="auto-accept-na-values"
        >
          {formatMessage({ id: 'insights.autoAccept.vs' })}
        </Typography>
        <AutoAcceptComponent
          label={messages['insights.autoAccept.USER']}
          element={
            <Skeleton
              className={classes.skeleton}
              data-testid="auto-accept-percentage-skeleton"
            />
          }
        />
      </Grid>
    </Paper>
  );
};
